class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = 140;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHoverOut.bind(this));
    this.addEventListener('focusin', this.openOnHover.bind(this));
    this.querySelector('.seed-menu-top-link')?.addEventListener('click', this.followTopLevelLink.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    window.clearTimeout(this.closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
  }

  closeOnHoverOut() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), this.closeDelay);
  }

  followTopLevelLink(event) {
    event.stopPropagation();
  }
}

customElements.define('header-menu', HeaderMenu);

class SeedStarDrawerMenu {
  constructor(trigger) {
    this.trigger = trigger;
    this.drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!this.drawer) return;

    this.trigger.addEventListener('click', this.open.bind(this));
    this.drawer.querySelectorAll('[data-seed-star-target]').forEach((button) => {
      button.addEventListener('click', this.selectPanel.bind(this));
    });
    this.drawer.querySelectorAll('[data-seed-star-drawer-close]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.drawer.addEventListener('keydown', this.onKeydown.bind(this));
  }

  open(event) {
    event.preventDefault();
    window.clearTimeout(this.closeTimer);
    document.querySelectorAll('[data-seed-star-drawer].is-open').forEach((drawer) => {
      if (drawer !== this.drawer) this.closeDrawer(drawer);
    });

    this.drawer.hidden = false;
    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('seed-star-drawer-open');
    });
  }

  close(event) {
    event?.preventDefault();
    this.closeDrawer(this.drawer);
    if (event?.currentTarget?.matches('[data-seed-star-drawer-close]')) this.trigger.focus();
  }

  closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.classList.remove('is-expanded');
    document.documentElement.classList.remove('seed-star-drawer-open');
    const trigger = document.querySelector(`[aria-controls="${drawer.id}"]`);
    trigger?.setAttribute('aria-expanded', 'false');

    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 180);
  }

  selectPanel(event) {
    const button = event.currentTarget;
    const targetId = button.dataset.seedStarTarget;
    const drawer = button.closest('[data-seed-star-drawer]');
    if (!drawer || !targetId) return;

    drawer.querySelectorAll('[data-seed-star-target]').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    drawer.querySelectorAll('.seed-star-drawer__product-panel').forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });

    drawer.classList.add('is-expanded');
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close(event);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-seed-star-drawer-open]').forEach((trigger) => {
    if (trigger.dataset.seedStarDrawerBound === 'true') return;
    trigger.dataset.seedStarDrawerBound = 'true';
    new SeedStarDrawerMenu(trigger);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-seed-star-drawer-open]').forEach((trigger) => {
    if (trigger.dataset.seedStarDrawerBound === 'true') return;
    trigger.dataset.seedStarDrawerBound = 'true';
    new SeedStarDrawerMenu(trigger);
  });
});
